import * as React from 'react';
import * as _ from 'lodash';
import * as Cookies from 'universal-cookie';
import { IListItem, IUser, ITicketGroup } from '@nkr/models/index';
import { TicketStatus, DisplayType } from '@nkr/enums/index';
import { GridApi, GridReadyEvent, RowClickedEvent, ColumnResizedEvent, ColumnMovedEvent, ColumnApi } from 'ag-grid-community';
import { FormControl, Glyphicon, Popover } from 'react-bootstrap';
import { TicketAction } from './ticket-action';
import { AdminListWrapper } from './styles';
import { FormControlWrapper } from '@nkr/views/swap-management/swaps/styles';
import { IRefreshInterval } from '@nkr/views/swap-management/swaps/models';
import styled from 'styled-components';
import { ITicketForList } from '@nkr/models/ticketing/ticket-for-list';
import AdminGrid from './admin-grid';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-bootstrap.css';

export const PopoverWrapper = styled(Popover) <{ width?: string }>`
    max-width: ${p => p.width ? p.width : '600px'};
    min-width: 500px;
    min-height: 550px;
    
    & > div {
        font-size: 12px;
    }
`;

const refreshIntervals: IRefreshInterval[] = [
    { value: 0, label: "Disable" },
    { value: 5, label: "5 seconds" },
    { value: 30, label: "30 seconds" },
    { value: 45, label: "45 seconds" },
    { value: 60, label: "60 seconds" }
];

interface IColumnDetails {
    colId: string,
    width: number,
    left: number
}

interface IProps {
    list: ITicketForList[],
    userList: IUser[],
    statusList: IListItem[],
    groupList: ITicketGroup[],
    width: string,
    display: DisplayType,
    loading: boolean,
    autoRefresh: number,
    onOpen: (ticketId: number) => void,
    onCloseReopen: (ticketId: number, status: TicketStatus) => void,
    onResolve: (ticketId: number) => void,
    onChangeAssignedUser: (ticketId: number, userId: number) => void,
    onChangeStatus: (ticketId: number, status: number) => void,
    onChangeGroup: (ticketId: number, groupId: number) => void,
    onChangeDisplay: (display: DisplayType) => void,
    onAutoRefreshChange: (autoRefresh: number) => void,
    onRefreshTicketList: () => void,
    onMouseOver: (id: number) => void,
    onMouseOut: () => void
}

interface IState {
    columnDetails: IColumnDetails[],
    currentTicket: number,
    gridApi: GridApi,
    columnApi: ColumnApi
}

class AdminList extends React.Component<IProps, IState> {
    readonly state: IState = {
        columnDetails: [],
        currentTicket: 0,
        gridApi: null,
        columnApi: null
    }

    refreshInterval: any;
    countdownInterval: any;

    componentDidMount = () => {
        var cookies = new Cookies();
        var columnDetails = cookies.get("TicketingList");

        if (columnDetails != null) {
            this.setState({
                columnDetails
            });
        }
    }

    componentWillReceiveProps = (nextProps: IProps) => {
        if (nextProps.autoRefresh != this.props.autoRefresh) {
            clearInterval(this.refreshInterval);

            if (nextProps.autoRefresh > 0) {
                this.refreshInterval = setInterval(() => this.refresh(), nextProps.autoRefresh * 1000);
            }
        }
    }

    handleDisplayChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.props.onChangeDisplay(parseInt(e.currentTarget.value));
    }

    handleRefresh = () => {
        this.refresh();
    }

    handleAutoRefreshChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        let autoRefresh = parseInt(e.currentTarget.value);
        this.props.onAutoRefreshChange(autoRefresh);
    }

    handleTicketAction = (id: number, action: TicketAction) => {
        switch (action) {
            case TicketAction.View:
                this.props.onOpen(id);
                break;

            case TicketAction.Close:
                this.props.onCloseReopen(id, TicketStatus.Closed);
                break;

            case TicketAction.Reopen:
                this.props.onCloseReopen(id, TicketStatus.Reopened);
                break;

            case TicketAction.Resolve:
                this.props.onResolve(id);
                break;
        }
    }

    onGridReady = (e: GridReadyEvent) => {
        this.setState({
            gridApi: e.api,
            columnApi: e.columnApi
        }, () => {
            if (this.state.columnDetails.length == 0) {
                let columnDetails: IColumnDetails[] = this.state.columnApi.getAllColumns().map((column, left) => {
                    let colId = column.getColId();
                    let width = column.getActualWidth();

                    return { colId, width, left };
                });

                this.setState({
                    columnDetails
                });
            } else {
                this.state.columnDetails.forEach(column => {
                    this.state.columnApi.moveColumn(column.colId, column.left);
                    this.state.columnApi.setColumnWidth(column.colId, column.width);
                });
            }
        });
    }

    handleRowClicked = (e: RowClickedEvent) => {
        let suppressRowClick = (e.api as any).gridOptionsWrapper.gridOptions.suppressRowClickSelection;

        if (!suppressRowClick) {
            let data = e.data as ITicketForList;
            this.props.onOpen(data.id);
        }
    }

    handleColumnResized = (e: ColumnResizedEvent) => {
        if (e.column != null) {
            let colId = e.column.getColId();
            let width = e.column.getActualWidth();

            let columnDetails = _.cloneDeep(this.state.columnDetails);
            let column = columnDetails.find(x => x.colId == colId);

            column.width = width;

            this.setState({
                columnDetails
            });
        }
    }

    handleColumnMoved = (event: ColumnMovedEvent) => {
        let colId = event.column.getColId();
        let left = event.toIndex;

        let columnDetails = _.cloneDeep(this.state.columnDetails);
        let currentColumn = columnDetails.find(x => x.colId == colId);
        let movedColumn = columnDetails.find(x => x.left == left);

        movedColumn.left = currentColumn.left < left ? movedColumn.left - 1 : movedColumn.left + 1;
        currentColumn.left = left;

        this.setState({
            columnDetails
        });
    }

    handleDragStopped = () => {
        let cookies = new Cookies();
        let columnDetails = this.state.columnDetails;

        cookies.set("TicketingList", columnDetails, { path: "/", domain: __DOMAIN__, secure: __ISSECURE__, httpOnly: false });
    }

    handleMouseOver = (e: React.MouseEvent, currentTicket: number) => {
        this.setState({
            currentTicket
        });
    }

    handleMouseOut = () => {
        this.setState({
            currentTicket: 0
        });
    }

    refresh = () => {
        this.props.onRefreshTicketList();
    }

    render = () => {
        const { userList, statusList, groupList } = this.props;
        const ticketList = this.props.loading == false ? this.props.list : [];
        const userGroupList = _.sortBy(_.uniqBy(userList.map(x => x.group), (item) => item.id), item => item.id);

        if (statusList.length == 0 || userList.length == 0) {
            return null;
        }

        return (
            <>
                <AdminListWrapper style={{ width: this.props.width ? this.props.width : '87%' }}>
                    <AdminGrid
                        data={ticketList}
                        display={this.props.display}
                        userList={userList}
                        userGroupList={userGroupList}
                        statusList={statusList}
                        groupList={groupList}
                        onGridReady={this.onGridReady}
                        onRowClicked={this.handleRowClicked}
                        onColumnResized={this.handleColumnResized}
                        onColumnMoved={this.handleColumnMoved}
                        onDragStopped={this.handleDragStopped}
                        onChangeAssignedUser={this.props.onChangeAssignedUser}
                        onChangeStatus={this.props.onChangeStatus}
                        onChangeGroup={this.props.onChangeGroup}
                    />

                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
                        <div style={{ fontSize: 12 }}>
                            {this.props.list.length} ticket(s) ...
                        </div>

                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ marginRight: 5, fontSize: 12 }}>Show:</div>
                            <div style={{ marginRight: 10 }}>
                                <FormControlWrapper
                                    value={this.props.display}
                                    componentClass="select"
                                    style={{ fontSize: 12 }}
                                    onChange={this.handleDisplayChange}
                                >
                                    <option value='1'>Menus</option>
                                    <option value='4'>No Menus</option>
                                </FormControlWrapper>
                            </div>
                        </div>

                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ marginRight: 5, fontSize: 12 }}>Auto refresh:</div>
                            <div style={{ marginRight: 5 }}>
                                <FormControlWrapper
                                    value={this.props.autoRefresh}
                                    componentClass="select"
                                    style={{ fontSize: 12 }}
                                    onChange={this.handleAutoRefreshChange}
                                >
                                    {refreshIntervals.map((interval, index) =>
                                        <option key={index} value={interval.value}>{interval.label}</option>
                                    )}
                                </FormControlWrapper>
                            </div>
                            <div>
                                <Glyphicon glyph="refresh" title="Refresh now" onClick={this.handleRefresh} />
                            </div>
                        </div>
                    </div>
                </AdminListWrapper>
            </>
        );
    }
}

export default AdminList;